import React from 'react';
import { Check, Book } from 'lucide-react';
const PURCHASE_URL = 'https://digitalespro.com/cart/47867900788950:1';
export function TomoSection() {
  const tomos = [{
    color: 'text-green-600',
    title: 'Tomo 1 – Descubriendo el Cuerpo Humano'
  }, {
    color: 'text-blue-600',
    title: 'Tomo 2 – El Centro de Control'
  }, {
    color: 'text-red-600',
    title: 'Tomo 3 – El Motor de la Vida'
  }, {
    color: 'text-orange-600',
    title: 'Tomo 4 – Energía y Movimiento'
  }, {
    color: 'text-purple-600',
    title: 'Tomo 5 – Defensas y Protección'
  }, {
    color: 'text-yellow-600',
    title: 'Tomo 6 – Vivir Saludable Todos los Días'
  }];
  const features = ['Explicaciones claras', 'Actividades prácticas', 'Juegos integrados', 'Proyecto final', 'Repaso evaluativo', 'Certificado para alumnos'];
  return <section className="bg-gray-50 py-16 md:py-24 px-4" data-id="element-218">
      <div className="max-w-5xl mx-auto" data-id="element-219">
        <div className="text-center mb-16" data-id="element-220">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4 font-['Oswald'] uppercase" data-id="element-221">
            📘 ¿Qué incluye exactamente el Pack?
          </h2>
          <p className="text-2xl text-blue-600 font-bold" data-id="element-222">
            6 Tomos Profesionales
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-223">
          <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-100" data-id="element-224">
            <ul className="space-y-4" data-id="element-225">
              {tomos.map((tomo, idx) => <li key={idx} className="flex items-center gap-3 text-lg font-bold text-gray-800 border-b border-gray-100 pb-2 last:border-0 last:pb-0" data-id="element-226">
                  <Book className={`w-6 h-6 ${tomo.color} flex-shrink-0`} data-id="element-227" />
                  <span data-id="element-228">{tomo.title}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-blue-50 p-8 rounded-xl border-2 border-blue-200" data-id="element-229">
            <h3 className="text-xl font-bold text-blue-900 mb-6 uppercase tracking-wide text-center" data-id="element-230">
              Cada tomo incluye:
            </h3>
            <ul className="space-y-3" data-id="element-231">
              {features.map((feature, idx) => <li key={idx} className="flex items-center gap-3" data-id="element-232">
                  <div className="bg-green-500 rounded-full p-1" data-id="element-233">
                    <Check className="w-4 h-4 text-white" data-id="element-234" />
                  </div>
                  <span className="text-lg text-gray-700 font-medium" data-id="element-235">
                    {feature}
                  </span>
                </li>)}
            </ul>
            <div className="mt-8 pt-6 border-t border-blue-200 text-center font-bold text-blue-800" data-id="element-236">
              Todo organizado para cubrir el programa completo del cuerpo
              humano.
            </div>
          </div>
        </div>

        <div className="text-center" data-id="element-237">
          <a href="#compra" className="bg-[#22c55e] hover:bg-[#16a34a] text-white text-2xl font-black py-4 px-10 rounded-lg shadow-[0_4px_0_#15803d] active:shadow-[0_2px_0_#15803d] active:translate-y-1 transition-all uppercase animate-pulse inline-block no-underline" data-id="element-238">
            👉 Acceder con descuento
          </a>
        </div>
      </div>
    </section>;
}